'use client';

import { useEffect, useState } from 'react';

/**
 * False during SSR and the initial client render; true after mount.
 * Use to defer react-aria / HeroUI overlays whose auto-generated ids can mismatch on hydration
 * when the surrounding tree differs subtly between server and client builds.
 */
export function useClientMounted(): boolean {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return mounted;
}
